export default __webpack_public_path__ + "static/media/background1.14e6bac3.jpg";